import type { GLTF } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { create } from 'zustand';
export interface PreloadStoreType {
  preloaded: { [key: string]: string | undefined };
  blobType: { [key: string]: string | undefined };
  load: (key: string, blob?: string, type?: string) => void;
  getBlob: (url: string) => string;
  getBlobType: (url: string) => string;

  glTFs: { [key: string]: GLTF };
  saveGLTF: (key: string, gltf: GLTF) => void;

  preloadAnimationFinished: boolean;
  setPreloadAnimationFinished: (isFinished: boolean) => void;

  experiencePreloadProgress: number;
  setExperiencePreloadProgress: (experiencePreloadProgress: number) => void;
}

export const usePreloadStore = create<PreloadStoreType>((set, get) => ({
  preloaded: {},
  blobType: {},
  load: (key, blob, type) =>
    set({
      preloaded: { ...get().preloaded, [key]: blob },
      blobType: { ...get().blobType, [key]: type },
    }),
  getBlob: url => get().preloaded[url] ?? url,
  getBlobType: url => get().blobType[url as string] as string,

  glTFs: {},
  saveGLTF: (key, gltf) => set({ glTFs: { ...get().glTFs, [key]: gltf } }),

  preloadAnimationFinished: false,
  setPreloadAnimationFinished: isFinished =>
    set({ preloadAnimationFinished: isFinished }),

  experiencePreloadProgress: 0,
  setExperiencePreloadProgress(experiencePreloadProgress) {
    set({ experiencePreloadProgress });
  },
}));
